const safeFileName = (file) => file?.name || file?.file_name || 'Document';
const safeFilePath = (file) => file?.key || file?.file_path || file?.path || safeFileName(file);

export const createPdfConversionId = (file) => {
    const runtimeCrypto = typeof window !== 'undefined' ? window.crypto : null;
    const randomPart = typeof runtimeCrypto?.randomUUID === 'function'
        ? runtimeCrypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    return `pdf-conversion-${randomPart}-${safeFilePath(file)}`;
};

/**
 * Bridges a server-side PDF conversion into the global UploadTray reducer.
 * The API is synchronous, so the percentages represent request stages rather
 * than byte-level progress. Status text remains the authoritative progress
 * indicator while the server performs the conversion.
 */
export const createPdfConversionProgressTracker = (dispatch, {
    file,
    caseName,
    ocrPdf = false
}) => {
    if (typeof dispatch !== 'function') {
        throw new TypeError('A valid UploadManager dispatch function is required.');
    }

    const id = createPdfConversionId(file);
    const name = safeFileName(file);
    const conversionLabel = ocrPdf ? 'searchable PDF' : 'PDF';

    dispatch({
        type: 'ADD_UPLOAD',
        payload: {
            id,
            operation: 'convert',
            file,
            name,
            path: safeFilePath(file),
            caseName,
            progress: 10,
            status: 'uploading',
            statusMessage: `Converting to ${conversionLabel}…`,
            startedAt: Date.now()
        }
    });

    return {
        id,
        responseReceived() {
            dispatch({
                type: 'UPDATE_UPLOAD',
                payload: {
                    id,
                    progress: 90,
                    statusMessage: 'Saving converted PDF…',
                    updatedAt: Date.now()
                }
            });
        },
        complete(result = null) {
            dispatch({
                type: 'UPDATE_UPLOAD',
                payload: {
                    id,
                    progress: 100,
                    status: 'complete',
                    statusMessage: 'Completed',
                    result,
                    completedAt: Date.now(),
                    updatedAt: Date.now()
                }
            });
        },
        fail(error) {
            const message = error instanceof Error ? error.message : String(error || 'Conversion failed');
            dispatch({
                type: 'UPDATE_UPLOAD',
                payload: {
                    id,
                    status: 'failed',
                    error: message,
                    statusMessage: 'Failed',
                    completedAt: Date.now(),
                    updatedAt: Date.now()
                }
            });
        }
    };
};
